var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { useDropzone } from 'react-dropzone';
import { TableWrapper, H2, Paragraph } from '@increasecard/typed-components';
import UploadArrow from '../images/upload.svg';
/* const TableContainer = styled(TableWrapper)<{ isDragActive: boolean }>`
  transition: all 200ms ease-out;
  ${({ isDragActive }) =>
    isDragActive
      ? `
        border: 3px solid #87B5FF;
        opacity: .5;
      `
      : null}
  & > div,
  & > table {
    transition: margin 200ms ease-out;
    margin: ${({ isDragActive }) => (isDragActive ? '-2px' : '0px')};
  }
`; */
var UploadImg = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 85px;\n  display: block;\n  margin-top: 10px;\n  user-select: none;\n"], ["\n  width: 85px;\n  display: block;\n  margin-top: 10px;\n  user-select: none;\n"])));
var CustomParagraph = styled(Paragraph)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-decoration: underline;\n  color: #0f6bff;\n  cursor: pointer;\n"], ["\n  text-decoration: underline;\n  color: #0f6bff;\n  cursor: pointer;\n"])));
var CenterWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  & h2,\n  & p {\n    text-align: center;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  & h2,\n  & p {\n    text-align: center;\n  }\n"])));
export function FileDropZone(_a) {
    var bottomLink = _a.bottomLink, children = _a.children, className = _a.className, accept = _a.accept, disabled = _a.disabled, onBottomLinkClick = _a.onBottomLinkClick, uploadMessage = _a.uploadMessage, uploadCTA = _a.uploadCTA, onDropAccepted = _a.onDropAccepted, onDropRejected = _a.onDropRejected, onDragEnter = _a.onDragEnter, onDragLeave = _a.onDragLeave;
    var _b = useDropzone({
        onDropAccepted: onDropAccepted,
        onDropRejected: onDropRejected,
        onDragEnter: onDragEnter,
        onDragLeave: onDragLeave,
        accept: accept,
        noClick: true,
        multiple: true
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps, open = _b.open, isDragActive = _b.isDragActive;
    return (React.createElement(TableWrapper, __assign({ className: className, style: { outline: 0 } }, getRootProps({ isDragActive: isDragActive })),
        React.createElement(CenterWrapper, null,
            children,
            React.createElement(UploadImg, { alt: "upload icon", draggable: "false", src: UploadArrow }),
            React.createElement("input", __assign({}, getInputProps(), { disabled: disabled })),
            React.createElement(H2, null, uploadMessage),
            React.createElement(CustomParagraph, { onClick: open }, uploadCTA),
            bottomLink && onBottomLinkClick && (React.createElement(CustomParagraph, { onClick: onBottomLinkClick, style: { marginTop: 32 } }, bottomLink)))));
}
var templateObject_1, templateObject_2, templateObject_3;
